"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Select = _interopRequireDefault(require("./Select"));
var _country = require("../../utils/country");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Country = function Country(props) {
  var countryCodes = props.countryCodes,
    locale = props.locale;
  var isDisabled = countryCodes && countryCodes.length == 1;
  var options = (0, _country.getCountryOptions)(countryCodes, locale).map(function (countryOption, index) {
    return /*#__PURE__*/_react.default.createElement("option", {
      value: countryOption.value,
      key: index
    }, ' ', countryOption.label, ' ');
  });
  return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({}, props, {
    isDisabled: isDisabled,
    options: options
  }));
};
Country.propTypes = {
  countryCodes: _propTypes.default.array,
  error: _propTypes.default.string,
  errorMessages: _propTypes.default.object,
  label: _propTypes.default.string,
  locale: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  props: _propTypes.default.object,
  validate: _propTypes.default.func,
  value: _propTypes.default.string
};
var _default = Country;
exports.default = _default;